import React, { SyntheticEvent } from "react";
import { FormControlLabel, Checkbox as MuiCheckbox } from "@material-ui/core";

type Props = {
  className?: string;
  checked: boolean;
  color?: "secondary" | "primary" | "default";
  label: string;
  disabled?: boolean;
  onChange?: (e: SyntheticEvent, checked: boolean) => void;
};

export const Checkbox = ({
  checked,
  className,
  color = "primary",
  label,
  disabled,
  onChange
}: Props) => {
  return (
    <FormControlLabel
      className={className}
      control={
        <MuiCheckbox
          disabled={disabled}
          checked={checked}
          color={color}
          onChange={onChange}
        />
      }
      label={label}
    />
  );
};
